import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CygovButtonComponent } from './cygov-button.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [CygovButtonComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [CygovButtonComponent],
})
export class CygovButtonModule {}
